
import React from "react";
import ContactForm from "../components/ContactPage/ContactForm";

function Contact() {
  return (
        <ContactForm />
  );
};

export default Contact;
